import { defineMessages } from "react-intl"

export default defineMessages({
  headerCoordinates: {
    id: "app.components.Coordinates.headerCoordinates",
  },
  city: {
    id: "app.components.Coordinates.city"
  },
  postalCode: {
    id: "app.components.Coordinates.postalCode"
  },
  phoneNumber: {
    id: "app.components.Coordinates.phoneNumber"
  },
})
